import {
  add,
  compare,
  decrement,
  increment,
  integerDivide,
  modulo,
  multiply,
  power,
  subtract,
  zero,
} from './api';

export const calculator = {
  add,
  compare,
  decrement,
  increment,
  integerDivide,
  modulo,
  multiply,
  power,
  subtract,
  zero,
};
